import { render, staticRenderFns } from "./MoneyBlock.vue?vue&type=template&id=0e65c473&scoped=true&"
import script from "./MoneyBlock.vue?vue&type=script&lang=ts&"
export * from "./MoneyBlock.vue?vue&type=script&lang=ts&"
import style0 from "./MoneyBlock.vue?vue&type=style&index=0&id=0e65c473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e65c473",
  null
  
)

export default component.exports